import React from "react";
import "../GalleryComponent/GalleryComponentCss/NaturalViewSection.css";

import img1 from "../Images/n1.jpg";
import img2 from "../Images/n2.jpg";
import img3 from "../Images/n3.jpg";
import img4 from "../Images/n4.jpg";

export default function NaturalViewSection() {
  return (
    <section className="natural-section">

      <h2 className="natural-title">नैसर्गिक दृश्य शेती डोंगर हिरवळ</h2>

      <div className="natural-grid">
        <div className="natural-card">
          <img src={img1} alt="view" />
        </div>

        <div className="natural-card">
          <img src={img2} alt="view" />
        </div>

        <div className="natural-card">
          <img src={img3} alt="view" />
        </div>

        <div className="natural-card">
          <img src={img4} alt="view" />
        </div>
      </div>
    </section>
  );
}
